// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"6667ab89","243":"974dd018","420":"4af5daf3","546":"a583cf3e","844":"f3e78a9f"}[chunkId] + ".chunk.css";
};